
import Vue from 'vue'

// import HarvestsDataTable from '@/ui/components/harvests/HarvestsDataTable.vue'

export default Vue.extend({
  components: {
    // HarvestsDataTable,
  },
  props: {
    plant: Object,
  },
  data: () => ({
    // sortBy: 'date',
    // sortDesc: true,
    itemsPerPage: 5, // -1,

    // headers: [
    //   { text: 'Date', value: 'date' },
    //   { text: 'Quantity', value: 'quantity' },
    //   { text: 'Quality', value: 'quality' },
    //   { text: 'Ripeness', value: 'ripeness' },
    //   { text: 'Size', value: 'size' },
    //   { text: 'Traits', value: 'traits' },
    // ],
  }),
  computed: {
    //
  },
})
